import { render, staticRenderFns } from "./ednUrl.vue?vue&type=template&id=27422088&"
import script from "./ednUrl.vue?vue&type=script&lang=js&"
export * from "./ednUrl.vue?vue&type=script&lang=js&"
import style0 from "./ednUrl.vue?vue&type=style&index=0&id=27422088&prod&lang=scss&"


/* normalize component */
import normalizer from "!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports